<template>
  <div id="contenedor-main-contrato-convenios" class="bkground">
    <tool-bar
      v-if="!soloLectura"
      v-on:registrarConvenio="mostrarRegistarConvenioModificatorio = true" />
    <listado :solo-lectura="soloLectura" />
    <v-dialog
      v-model="mostrarRegistarConvenioModificatorio"
      width="600">
      <registrar-nuevo-convenio-modificatorio
        v-if="mostrarRegistarConvenioModificatorio"
        :contrato="getContrato"
        v-on:cerrar="cerrarVentana"/>
    </v-dialog>
    <v-dialog
    v-if="esteConvenioModificatorio"
      v-model="mostrarEditarConvenioModificatorio"
      width="600">
      <editar-convenio-modificatorio
        :convenioModificatorioEditar="esteConvenioModificatorio"
        :contrato="getContrato"
        v-on:cerrar="cerrarVentana"/>
    </v-dialog>
    <v-dialog
      v-if="esteConvenioModificatorio"
      v-model="mostrarEliminarConvenioModificatorio"
      :width="!$vuetify.breakpoint.xs ? '450' : '90%'">
      <eliminar-convenio-modificatorio
        :convenioModificatorioEliminar="esteConvenioModificatorio"
        v-on:cerrar="cerrarVentana"/>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import RegistrarNuevoConvenioModificatorio from '@/components/administracion/contratos/contrato/convenio/Nuevo.vue';
import EditarConvenioModificatorio from '@/components/administracion/contratos/contrato/convenio/Editar.vue';
import EliminarConvenioModificatorio from '@/components/administracion/contratos/contrato/convenio/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainContratoConvenios',
  props: {
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    ToolBar,
    Listado,
    RegistrarNuevoConvenioModificatorio,
    EditarConvenioModificatorio,
    EliminarConvenioModificatorio,
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
  },
  data() {
    return {
      mostrarRegistarConvenioModificatorio: false,
      mostrarEditarConvenioModificatorio: false,
      mostrarEliminarConvenioModificatorio: false,
      esteConvenioModificatorio: null,
    };
  },
  methods: {
    cerrarVentana() {
      this.mostrarRegistarConvenioModificatorio = false;
      this.mostrarEditarConvenioModificatorio = false;
      this.mostrarEliminarConvenioModificatorio = false;
      this.esteConvenioModificatorio = null;
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
  },
  mounted() {
    eventBus.$on('editar-convenio-modificatorio', (convenioModificatorio) => {
      this.esteConvenioModificatorio = convenioModificatorio;
      this.mostrarEditarConvenioModificatorio = true;
    });
    eventBus.$on('eliminar-convenio-modificatorio', (convenioModificatorio) => {
      this.esteConvenioModificatorio = convenioModificatorio;
      this.mostrarEliminarConvenioModificatorio = true;
    });
  },
};
</script>

<style lang="scss">

</style>
